export const PixelButton = ({ variant = "primary", className = "", children, ...props }) => (
  <button className={`pixel-btn pixel-btn-${variant} ${className}`} {...props}>
    {children}
  </button>
);
